export default class MainHero {
    constructor() {
        this.section = document.querySelector(".no-main-hero");
        if (!this.section) return;

        this.init();
    }

    init() {
        this.content = this.section.querySelector(".no-main-hero__content");
        if (!this.content) return;

        this.title = this.content.querySelector("h1");
        this.description = this.content.querySelector("p");
        this.button = this.content.querySelector("a");

        this.animateText();
    }

    animateText() {
        const tl = gsap.timeline({ delay: 0.2 });

        // Title 애니메이션
        if (this.title) {
            const titleSplit = new SplitType(this.title, {
                types: "words",
                tagName: "span",
            });

            const titleWords = this.title.querySelectorAll(".word");

            gsap.set(titleWords, {
                yPercent: 100,
                opacity: 0,
            });

            tl.to(titleWords, {
                yPercent: 0,
                opacity: 1,
                duration: 0.5,
                stagger: 0.015,
                ease: "power3.out",
            });
        }

        // Description 애니메이션
        if (this.description) {
            const descSplit = new SplitType(this.description, {
                types: "words",
                tagName: "span",
            });

            const descWords = this.description.querySelectorAll(".word");

            gsap.set(descWords, {
                yPercent: 100,
                opacity: 0,
            });

            tl.to(
                descWords,
                {
                    yPercent: 0,
                    opacity: 1,
                    duration: 0.4,
                    stagger: 0.015,
                    ease: "power3.out",
                },
                "-=0.3"
            );
        }

        // Button 애니메이션
        if (this.button) {
            gsap.set(this.button, {
                y: 30,
                opacity: 0,
            });

            tl.to(
                this.button,
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.4,
                    ease: "power3.out",
                },
                "-=0.2"
            );
        }
    }
}
